@if (imageDefs && imageDefs.length > 0) {
  <div class="ignite-image-carousel-container">
    <ignite-swiper>
      @for (imgDef of imageDefs; track imgDef) {
        <div swiper-card>
          @if (imgDef.title) {
            <div class="title">
              {{ imgDef.title }}
            </div>
          }
          <div class="image">
            <img src="{{ imgDef.imageUrl }}" [style.max-width]="imgDef.width" [style.max-height]="imgDef.height" />
            @if (imgDef.expandable) {
              <div class="expand-container" (click)="expandImage(imgDef)"></div>
            }
            <i class="fas fa-expand" (click)="expandImage(imgDef)"></i>
          </div>
          @if (imgDef.description) {
            <div class="description">
              {{ imgDef.description }}
            </div>
          }
        </div>
      }
    </ignite-swiper>
  </div>
}
